import { createFileRoute } from "@tanstack/react-router"

import { OverviewPage } from "~/components/design-system/pages"
import { FreshnessPanel } from "~/components/ingestion-cockpit/FreshnessPanel"
import { PipelineSection } from "~/components/ingestion-cockpit/PipelineSection"

export const Route = createFileRoute("/_auth/ingestion-cockpit/_layout/")({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <OverviewPage>
      <div className="flex flex-col gap-4">
        <PipelineSection />
        <FreshnessPanel />
      </div>
    </OverviewPage>
  )
}
